module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/029f2533163e160cd39075be03c3db73.png";